import { resolveContentfulImageCdnOriginForLocale } from '~/utils/contentful/rewriteContentfulAssetHostsByLocale';

/**
 * Early `<link rel="preconnect">` for the Contentful image CDN.
 * Uses the same locale policy as asset URL rewriting (`zh-cn` → `.cn`).
 */
export function useContentfulImageCdnPreconnect() {
  const { $activeLocale } = useNuxtApp();

  useHead({
    link: computed(() => [
      {
        key: 'contentful-image-cdn-preconnect',
        rel: 'preconnect',
        href: resolveContentfulImageCdnOriginForLocale(
          $activeLocale.value.webapp
        )
      }
    ])
  });
}
